// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__IWLnS","info":"PatientInfo_info__K-ZAq"};